import {
  FilterMode,
  DocumentGenerationParams_OrderBy,
  DocumentGenerationParams,
  SortOrder,
  DocumentGenerationParams_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const documentGenerationParamsService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.documentGenerationParamsOne({ id });
    return result.documentGenerationParamsOne as DocumentGenerationParams;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: DocumentGenerationParams_OrderBy[] | null = null,
    filter: DocumentGenerationParams_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: DocumentGenerationParams_Filter | undefined;
    if (searchValue !== "") {
      where = { id: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.documentGenerationParamsListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : { id: SortOrder.Asc },
      where,
    });
    const list = nullToUndefinedRecursive(
      result.documentGenerationParamsListWithOffset
    ) as DocumentGenerationParams[];
    return { list, orderBy };
  },
};
